import { Button } from "../../../designSystems/components/Button"
import leftArrow from "../../../assets/img/icons/left-arrow-white.svg"
import illustraMap from '../../../assets/img/illustra-map.svg'
import fundacaoMboi from '../../../assets/img/fundacao-mboi.svg'
import { useNavigate } from "react-router"
import { Container } from "./style"
import { useContext } from "react"
import { Form } from "semantic-ui-react"
import { Controller, SubmitHandler, useForm } from "react-hook-form"
import { GlobalContext } from "../../../context/GlobalContext"
import { requestNewPassword } from "../../../api/authentication"

type Props = {
    email: string
}

export const RequestNewPasswordPage = (): JSX.Element => {
    const { control, handleSubmit, formState: { errors } } = useForm<Props>(
        { defaultValues: { email: '' } }
    );
    const { setIsLoading, setDataToast } = useContext(GlobalContext)

    const navigate = useNavigate()

    const goToPage = (path: string): void => {
        navigate(path)
    }

    const onSubmit: SubmitHandler<Props> = data => {
        setIsLoading(true)
        requestNewPassword(data).then((response: any) => {
            setIsLoading(false)
            setDataToast({ show: true, text: response.data.message })
            goToPage('/login')
        }).catch(err => {
            setIsLoading(false)
            const textError = err.response.data.message === 'Unauthorized' ? 'Erro ao solicitar nova senha' : err.response.data.message
            setDataToast({ show: true, text: textError })
        })
    }

    return (
        <Container>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6">
                        <div className="left-content">
                            <div className="btn-back">
                                <Button
                                    text={'Voltar ao mapa'}
                                    icon={leftArrow}
                                    height="42px"
                                    type="button"
                                    background="transparent"
                                    className="radius-8 float-left btn-register"
                                    onClick={(event) => {
                                        event.preventDefault()
                                        goToPage('/mapa')
                                    }}
                                />
                            </div>

                            <div className="login-container">
                                <div className="title-content">Recupere sua senha</div>
                                <p className="subtitle">Informe o e-mail da sua conta para receber o pedido de nova senha.</p>

                                <div className="login">
                                    <div className="d-block text-center">
                                        <div className="title">Solicitar nova senha</div>
                                        <p className="hint">Escreva o e-mail usado no Mapa PerifaSul.</p>

                                        <form
                                            className="ui form"
                                            onSubmit={(event) => {
                                                event.preventDefault()
                                                void handleSubmit(onSubmit)(event)
                                            }}
                                        >
                                            <Controller
                                                name="email"
                                                control={control}
                                                rules={{
                                                    required: true,
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: "invalid email address"
                                                    }
                                                }}
                                                render={({ field: { onChange, value } }) => (
                                                    <>
                                                        <Form.Input
                                                            fluid
                                                            label="E-mail *"
                                                            type="email"
                                                            placeholder="exemplo@exemplo.com"
                                                            className={errors.email && 'field-error'}
                                                            value={value}
                                                            onChange={function (e, { value }) {
                                                                onChange(value)
                                                            }}
                                                        >
                                                            <input />
                                                        </Form.Input>
                                                        {errors.email?.type === 'required' && <p className="field-error-msg">Campo obrigatório</p>}
                                                        {errors.email?.type === 'pattern' && <p className="field-error-msg">E-mail inválido</p>}
                                                    </>
                                                )}
                                            />

                                            <Button className="btn-submit radius-100" type="submit" text="Enviar solicitação" />
                                            <Button
                                                hasShadow={false}
                                                className="btn-forget"
                                                type="button"
                                                background="transparent"
                                                text="Voltar para o login"
                                                onClick={(event) => {
                                                    event.preventDefault()
                                                    goToPage('/login')
                                                }}
                                            />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 stage">
                        <div className="right-content">
                            <img className="map" src={illustraMap} alt="Mapa da zona sul de São Paulo" />
                            <img className="brand" src={fundacaoMboi} alt="Fundo Comunitário PerifaSul M'Boi" />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}
